import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import Chat from "./App";
import Dashboard from "./Dashboard";
import AuthGate from "./AuthGate";
import "./index.css";

// The theme is applied BEFORE this file runs, by the inline script in index.html.
// Doing it here — or in an effect — is too late: the browser has already painted,
// and a dark-mode user gets a white flash on every load. This module only imports
// the stylesheet; theme.ts is used from the toggle onwards.

// ONE ROUTE CHECK, not a router. There are exactly two pages and no nested or
// parameterised routes, so react-router would add a dependency and a bundle to express
// a single boolean. If a third page ever appears, that is the moment to add one.
//
// Read once at mount rather than watched: both pages are full-page and reached by a
// plain link, so there is no in-app navigation to keep in sync.
const isDashboard = window.location.pathname.replace(/\/+$/, "") === "/dashboard";

// BOTH pages go through the gate. Rendering a page outside it is what produced the
// dashboard's 401: it fetched with auth uninitialised, took getApiToken's local-dev
// early return, and sent no Authorization header.
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AuthGate>{(account) => (isDashboard ? <Dashboard /> : <Chat account={account} />)}</AuthGate>
  </StrictMode>,
);
